<template>
  <v-list style="min-width: 250px" class="bg-background rounded-lg pa-3">
    <v-list-item>
      <v-row no-gutters>
        <v-avatar class="mr-3 mt-1">
          <img v-if="avatarSrc" :src="avatarSrc" width="100%" height="auto" />
          <v-icon v-else icon="custom:avatar" size="100%" />
        </v-avatar>
        <v-card-subtitle class="d-flex flex-column text-grey pt-0">
          <span
            class="font-weight-medium text-h6 text-pwt_black"
            style="line-height: 24px"
          >
            {{ user ? user.fullName : "" }}
          </span>
          <span class="pb-2 text-pwt_black" style="line-height: 18px">
            {{ user ? user.email : "" }}
          </span>
        </v-card-subtitle>
        <v-spacer />
      </v-row>
    </v-list-item>
    <v-divider class="mb-3" />
    <v-list-item @click="handleChangeDashboardTab('account')">
      <v-list-item-title> Manage account </v-list-item-title>
    </v-list-item>
    <v-list-item @click="handleChangeDashboardTab('my-fleet')">
      <v-list-item-title> My fleet </v-list-item-title>
    </v-list-item>
    <v-list-item @click="handleChangeDashboardTab('fleet-vehicles')">
      <v-list-item-title> Fleet vehicles </v-list-item-title>
    </v-list-item>
    <v-list-item @click="handleChangeDashboardTab('fleet-locations')">
      <v-list-item-title> Fleet locations </v-list-item-title>
    </v-list-item>
    <v-list-item @click="handleChangeDashboardTab('saved-trips')">
      <v-list-item-title> Saved trips </v-list-item-title>
    </v-list-item>
    <v-divider class="mb-3" />
    <v-list-item @click="handleLogout">
      <v-list-item-title
        class="text-decoration-underline text-primary"
        style="text-underline-offset: 4px"
      >
        Sign out
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script lang="ts" setup>
import type User from "@/domains/user/user";
import { useUserStore } from "@/domains/user/userStore";
import { useAppStore } from "@/stores/appStore";
import {
  useDashboardNavStore,
  type DashboardDialogContent,
} from "@/stores/dashboardNavStore";
import { computed } from "vue";

const emit = defineEmits(["close"]);

const userStore = useUserStore();

const user = computed<User | undefined>(() => userStore.getCurrentUser);
const avatarSrc = computed<string | undefined | null>(
  () => user.value?.avatarURL,
);

const appStore = useAppStore();

function handleLogout() {
  emit("close");
  appStore.logout();
}

const dashboardNavStore = useDashboardNavStore();

function handleChangeDashboardTab(tab: DashboardDialogContent) {
  dashboardNavStore.displayedContent = tab;
  emit("close");
}
</script>
